<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });

defineProps<{ id: string }>();
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:scissors-line-dashed" accent="reporting">
    <p class="text-[12.5px] text-muted-foreground">
      {{ t("description") }}
    </p>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Page Break"
  description: "No configuration is needed. The PDF compiler inserts a page break here."
</i18n>
